module.exports = __webpack_public_path__ + "img/photos/placeholders/trailer@2x.jpg";